<template>
  <div id='ae' class='' v-loading='loading'>
  

  <el-dialog  class='gDia' :title="$t('app_addPush')" v-model="dialogVisible" size='middle'>
    <div style='width:100%;background:none;text-align:left;' class='gDiaTable'>

      <span>
        <!-- <el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="channelId" clearable :placeholder="$t('app_distributor')">
          <el-option
            v-for="item in channels"
            :key="item.mechanismid"
            :label="item.mechanismname"
            :value="item.mechanismid">
          </el-option>
        </el-select> -->
      </span>


      <el-col :span="6">
        <div style='margin-right:16px;'>
          <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
        </div>
      </el-col>
   

      <span>
        <el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="status" clearable :placeholder="$t('app_status')">
          <el-option
            v-for="item in sstatusAr"
            :key="item.vl"
            :label="item.lb"
            :value="item.vl">
          </el-option>
        </el-select>
      </span>


      <el-input
      :placeholder="$t('app_searchTerminal')"
      icon="search"
      @keyup.enter.native='srchDevice'
      style='width:40%;margin-bottom:10px;'
      v-model="srchValue">
      </el-input>
    </div>




    <el-table
    :data="tableData"
    v-loading='dLoading'
    border
    tooltip-effect="dark"
    style="width: 100%">
      <el-table-column
        align='center'
        prop="terminalNo"
        :label="$t('app_terNo')"
        width="150">
      </el-table-column>
      <el-table-column
        align='center'
        prop="terminalName"
        :label="$t('app_terName')"
        width="130">
      </el-table-column>
      <el-table-column
        prop="status"
        align='center'
        :formatter="setSt"
        :label="$t('app_status')"
        width="90">
        <!-- <template slot-scope="scope">
          <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                  <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                  <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
                  <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
        </template> -->
      </el-table-column>
      <el-table-column
        align='center'
        prop="mechName"
        :label="$t('app_distributor')"
        width=''>
      </el-table-column>
      <el-table-column
        prop="operate"
        :label="$t('app_operate')"
        align='center'
        width='80'>
        <template slot-scope='scope'>
          <!-- <el-button   @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
            <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="gPgDiv" style=''>

      <el-pagination
      @current-change="pageSelect"
      @size-change="pageSized"
      :current-page="index"
      :page-sizes='$gRows'
      :page-size="$gRow"
      class='gPg'
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
      <!-- <el-pagination
        small
        layout="prev, pager, next"
        :total="total">
      </el-pagination> -->

    </div>

  </el-dialog>

  <el-dialog class='gDia' :title="$t('app_banReason')" v-model="notPassDialog">
    <el-form :model="form">
      <el-form-item :label="$t('app_reason')" label-width="14%">
        <el-input v-model="reason" ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="notPassDialog = false">{{$t('app_cancel')}}</el-button>
      <el-button type="primary" @click="verifyRqs('3')">{{$t('app_submit')}}</el-button>
    </div>
  </el-dialog>

    <el-button @click="push()" type='primary'>{{$t('app_addPush')}}</el-button>
    <el-button @click="downf()" type='primary'>{{$t('app_downfile')}}</el-button>

    <div class='gPageBorder gTopMg' v-show="true" style=''>
      
      <p class='gCtColor gPTitle' style=''>{{$t('app_baseInfo')}} </p>

      <el-row class='gPdTB'>

        <el-col :span='24'>
            <el-form class='gShowLeftForm'  label-position='left' label-width="15%">
                <el-form-item :label="$t('app_srcname') " style="width:calc(100% - 10px);">
                  {{config?config.name : ''}}
                </el-form-item>
            </el-form>
        </el-col>

        <el-col :span='24'>
            <el-form class='gShowLeftForm'  label-position='left' label-width="15%">
                <el-form-item :label="$t('lin_global.risk_desc') " style="width:calc(100% - 10px);">
                  {{config?config.memo : ''}}
                </el-form-item>
            </el-form>
        </el-col>

        <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
            <el-form-item :label="$t('app_newgVer') ">
              {{config?config.version : ''}}
            </el-form-item>
        </el-form>
        </el-col>

        <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
            <el-form-item label="MD5">
              {{config?config.hashCode : ''}}
            </el-form-item>
        </el-form>
        </el-col>

        <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
            <el-form-item :label="$t('app_distributor') ">
              {{config?config.mechanismName : ''}}
            </el-form-item>
        </el-form>
        </el-col>

        <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
            <el-form-item :label="$t('app_fileSize') ">
              {{config?(config.size/1000000).toFixed(2) : ''}}MB
            </el-form-item>
        </el-form>
        </el-col>

      </el-row>
     
      <!-- <div style='background:none;padding: 0 0px 24px 0px;margin-left:20px;'>
            <el-button @click="$router.go(-1);">{{$t('app_cancel')}}</el-button>
            <el-button @click="verify('2')" type='success'>{{$t('app_psverify')}}</el-button>
            <el-button @click="verify('3')" type='danger'>{{$t('app_ban')}}</el-button>
            <el-button @click="dialogVisible = true;" type='primary' style='margin-left:20px;'>{{$t('app_pushInstallTest')}}</el-button>
            <el-button @click="downf()" type='primary'>{{$t('app_downfile')}}</el-button>
      </div> -->
    </div>


    
     
   

  

  </div>
</template>

<style>
  .ldt-word-main{color:rgb(72,87,106)}
  .ldt-word-title{color:#99A9BF;}
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
  }

  .ldt-launch{width:calc(100% - 48px);height:100%;background:none;}
    .ldt-launch td{width:30%;background:none;}

  /* upload */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  /* upload */
  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import mm from 'moment'
  import df from '../../../assets/df.png'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default {
    data () {
      var that = this
      return {
        dLoading: false,
        srchValue: '',
        reason: '',
        config: '',
        captures: [],
        sstatus: {
          '0': this.$t('app_new'),
          '1': this.$t('app_on'),
          '2': this.$t('app_sleep'),
          '3': this.$t('app_fault')
        },
        sstatusAr: [
          {vl:'',  lb: this.$t('app_all')},
          {vl:'0', lb: this.$t('app_new')},
          {vl:'1', lb: this.$t('app_on')},
          {vl:'2', lb: this.$t('app_sleep')},
          {vl:'3', lb: this.$t('app_fault')}
        ],
        loading: 0,
        dialogVisible: false,
        notPassDialog: false,
        index: 1,
        tableData: [],
        total: 0,
        status: '',
        tags: [],
        mech: '',
        stModel: [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_sleep'), vl: '3'},
          // {label: '锁定', vl: '2'}
        ],
        mechanismData: {
          callback (value) {
            that.mech = value
            that.selectChange(value)
          }
        }
      }
    },
    components: {
      MechanismSelector
    },
    computed: {
      /*avtStyle () {
        var url = this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : require('../../../assets/df.png')
        
        return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')'
      },*/
      showUploadNew () {
        console.log('ccc', this.config.data)
        if (this.config.data) {
          if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {
      push () {
        this.$setWObj('pushList', {data: this.config, type: '15'})
        this.$router.push({path: '/non-it-eq/src/detail/push'})
      },
      downf () {
        window.open(this.$host + this.config.url)
      },
      setSt (row) {
        return this.sstatus[row.terminalStatus]
      },
      bindOperate (row) {
        this.dLoading = 1
        this.$asTestPush(this.config.id, row.terminalNo, (res) => {
          this.dLoading = 0
          if (res.status === 200) {
            this.$message.success(this.$t('app_tipViewTask'))
            this.notPassDialog = false
          } else {
            this.$message.error(res.message)
          }
        }, (error) => {
          this.dLoading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      verify (vl) {
        if (vl === '2') {
          // yes
          this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            this.verifyRqs(vl)
          }).catch(() => {
          })
        } else if (vl === '3') {
          // no
          this.notPassDialog = true
        }
      },
      verifyRqs (vl) {
        this.loading = 1
        this.$assubmit(this.config.id, this.reason, vl, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
          this.loading = 0
        })
      },
      srchDevice () {
        this.getDevices()
      },
      selectChange (vl) {
        this.getDevices()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        // var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        var mc = this.mech
        
        this.loading = 1
        this.$getNonItDv(this.index, this.$gRow, mc, '', status,'', '', '','','', (res) => {
            console.log('dv', res)
            this.loading = 0
            if (res.data) {
              this.tableData = res.data
              this.total = res.total
            }
          }, () => {
            // error
            this.loading = 0
          })

      },
      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {
        this.getDevices()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getDevices()
      },
     


      deleteAppHis (row) {
        // console.log(row)
        if (row.applicationid) {
          this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            this.loading = 1
            if (this.$appUrlTag === 0) {
              this.$deleteApp(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            } else {
              this.$deleteAppHis(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            }
          }).catch(() => {
          })
        }
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
        } else {
          return ''
        }
      },

      getAppHistory () {
        if (!this.config.data.appName) {
          return
        }
        // console.log('pkg', this.config.data)
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$getAppHistory(this.config.data.appName, this.config.data.packagename, (res) => {
            //console.log('his', res)
            //alert(res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          
          this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, (res) => {

            console.log('his', res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      },
      uploadNew () {
        // this.config = {type: 4, data: this.config}
        // this.$router.push({name: this.$t('menu.appManageSub.uploadNew')})
      },
      init () {
        // this.config = this.$route.query
        this.config = this.$getWObj().nsObj
        console.log(this.$route, this.config)
        // this.getDevices()
      },
      
    },
    mounted () {
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// detail.vue?3209a89b